import { Permission } from '@/lib/permissions/v1'
import { Route } from '@/composables/route'

export const setRouteQueries = async (route: Route) => {
    await route.addSortItem({
        column: 'title',
        direction: 'asc',
    })
}

export enum CompanyLocationRouteName {
    Index = 'company.locations.index',
    Create = 'company.locations.create',
    Edit = 'company.locations.edit',
    Show = 'company.locations.show',
    Logs = 'company.locations.logs',
    LogDetails = 'company.locations.logs.details',
}

export default {
    path: 'locations',
    name: CompanyLocationRouteName.Index,
    component: () => import('@/views/company/location/Index.vue'),
    meta: {
        label: 'Company Locations',
        auth: true,
        permission: Permission.CompanySiteViewAny,
    },
    children: [
        {
            path: 'create',
            name: CompanyLocationRouteName.Create,
            component: () => import('@/views/company/location/Index.vue'),
            meta: {
                label: 'Create Location',
                auth: true,
                permission: Permission.CompanySiteCreate,
            },
        },
        {
            path: ':locationUuid/edit',
            name: CompanyLocationRouteName.Edit,
            component: () => import('@/views/company/location/Index.vue'),
            meta: {
                label: 'Edit Location',
                auth: true,
                permission: Permission.CompanySiteUpdate,
            },
        },
        {
            path: ':locationUuid',
            name: CompanyLocationRouteName.Show,
            component: () => import('@/views/company/location/Index.vue'),
            meta: {
                label: 'Location Details',
                auth: true,
                permission: Permission.CompanySiteView,
            },
        },
        {
            path: ':locationUuid/logs',
            name: CompanyLocationRouteName.Logs,
            component: () => import('@/views/company/location/Index.vue'),
            meta: {
                label: 'Location Logs',
                auth: true,
                permission: Permission.EventViewAny,
            },
            children: [
                {
                    path: ':logId',
                    name: CompanyLocationRouteName.LogDetails,
                    component: () => import('@/views/company/location/Index.vue'),
                    meta: {
                        label: 'Log Details',
                        auth: true,
                        permission: Permission.EventView,
                    },
                },
            ],
        },
    ],
}
